module.exports = __webpack_public_path__ + "static/media/side-banner.0d22b4e6.jpg";